/**
 * A prévia da última mensagem na lista de conversas, como no WhatsApp
 * (pedido do Igor, 2026-10-28):
 *  - minha última: ✓/✓✓/✓✓ azul na frente e "Você:", sem abrir a conversa;
 *  - áudio: microfone em SVG (azul quando ouvido) no lugar do emoji;
 *  - conversa direta: a mensagem da outra pessoa vai sem o nome (é ela).
 * O servidor manda `minha`, `tipo`, `marca` e `ouvido` já para quem vê.
 */
import { TextoComEmojis } from "./TextoComEmojis";
import { MarcaDeEnvio, MicDoAudio } from "./Marcas";

const ROTULO_SEM_TEXTO = { audio: "Áudio" };

export function PreviaDaUltima({ ultima, direta }) {
  const quem = ultima.minha ? "Você" : direta ? null : ultima.autor_nome;
  const ehAudio = ultima.tipo === "audio";
  return (
    <span className="pchat-previa-ultima">
      {ultima.minha && <MarcaDeEnvio marca={ultima.marca || "enviada"} />}
      {quem && <em>{quem}:</em>}
      {ehAudio ? (
        <>
          <MicDoAudio ouvido={!!ultima.ouvido} tamanho={14} />
          <span>{ROTULO_SEM_TEXTO.audio}</span>
        </>
      ) : ultima.texto ? (
        <TextoComEmojis texto={ultima.texto} mencoes={false} />
      ) : (
        <span>anexo</span>
      )}
    </span>
  );
}
